import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DetailsTable = ({ header, rows }) => (
  <div className="details-table">
    {header && <h3>{header}</h3>}
    {rows.map(({ label, value, className }) => (
      <div className="details-row" key={label}>
        <div className="label">{label}</div>
        <div
          className={classNames({
            data: true,
            [className]: !!className,
          })}
        >
          {value}
        </div>
      </div>
    ))}
  </div>
);

DetailsTable.displayName = 'DetailsTable';

DetailsTable.defaultProps = {
  header: '',
};

DetailsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
    className: PropTypes.string,
  })).isRequired,
  header: PropTypes.string,
};

export default DetailsTable;



// WEBPACK FOOTER //
// ./src/components/DetailsTable.js